// extracted by mini-css-extract-plugin
export var divider = "_fd-7";
export var itemsToggle = "_fd-8";
export var mergeModal = "_fd-1";
export var optionCard = "_fd-4";
export var radioGroup = "_fd-6";
export var radioOption = "_fd-0";
export var selected = "_fd-5";
export var shipmentOptions = "_fd-2";
export var tableOptions = "_fd-3";